<template>

    <div v-if="show">

        <div class="btmsht__overlay" :class="{'overlay-big-size': isBigSize}" @click.self="overlayClick">
            <transition name="bottomiscomming">

                <div v-show="showAfter" v-touch:swipe.bottom="swipeBottom" class="btmsht__container" :class="{'max-width': maxWidth, 'container-big-size': isBigSize}">

                    <div v-if="!isBigSize" class="btmsht__handle"></div>

                    <slot></slot>

                </div>

            </transition>

        </div>

    </div>

</template>

<script>
import Vuex from 'vuex'

export default {

    name: 'bottom-sheet',

    props: {

        selfClose: {
            type: Boolean,
            default: false
        },

        maxWidth: {
            type: Boolean,
            default: true
        },

        // Specific pixel width before the bottom sheet is considered big size, if 0, extraSize is not used
        extraSize: {
            type: 0,
            default: Number
        }
    },

    watch: {

        show: function (bool) {

            if (bool) {

                setTimeout(() => {
                    this.showAfter = bool
                }, 200)
            }
        }
    },

    computed: {

        ...Vuex.mapGetters([
            'innerWidth'
        ]),

        isBigSize() {
            return this.extraSize
                ? this.innerWidth > this.extraSize
                : this.isDesktop
        }
    },

    data() {
        return {
            show: false,
            showAfter: false
        }
    },

    methods: {

        open() {
            this.show = true
        },

        close() {
            this.show = false
            this.showAfter = false
        },

        swipeBottom() {

            if (!this.extraSize) {

                this.close()
            }
        },

        overlayClick() {
            if (this.selfClose) {
                this.close()
            }
        }
    }
}

</script>

<style lang="scss" scoped>

.btmsht {
    &__container {
        position: fixed;
        left: 0;
        right: 0;
        bottom: 0;
        max-height: 95vh;
        border-radius: 8px 8px 0 0;
        box-shadow: 0 16px 24px 0 rgba(0, 0, 0, 0.08);
        background-color: $white;
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    &__handle {
        width: 40px;
        height: 6px;
        border-radius: 6px;
        margin: 12px 0;
        background-color: #d7d9df;
    }

    &__overlay {
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        z-index: 2;
        animation: overlayiscomming 200ms 0s 1 normal ease-in-out forwards;
    }
}

.max-width {
    @media screen and (min-width: $above-tablet-length) {
        max-width: 480px;
    }
}

.container-big-size {
    position: relative;
    border-radius: 24px;
}

.overlay-big-size {
    display: flex;
    align-items: center;
    justify-content: center;
}

/*animation*/


@keyframes overlayiscomming {
    0% {
        background-color: rgba(0, 0, 0, 0)
    }
    100% {
        background-color: rgba(0, 0, 0, 0.5)
    }
}

.bottomiscomming-enter-active {
    transition: 0.6s cubic-bezier(0.23, 1, 0.32, 1);
}

.bottomiscomming-leave-active {
    transition: 0.2s cubic-bezier(0.755, 0.05, 0.855, 0.06);
}

.bottomiscomming-enter {
    transform: translate(0, 100%);
    opacity: 0;
}

.bottomiscomming-leave-to {
    opacity: 0;
}

</style>
